import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export function categoryTopSlider() {
  const container = document.querySelector('[data-category-top-posts]');
  if (!container) return;

  const mql = window.matchMedia('(max-width: 768px)');
  let swiper = null;

  function initSlider() {
    if (swiper) return;

    // Wrap children in swiper structure
    container.classList.add('swiper');
    const slides = Array.from(container.children);
    const wrapper = document.createElement('div');
    wrapper.classList.add('swiper-wrapper');
    slides.forEach(slide => {
      slide.classList.add('swiper-slide');
      wrapper.appendChild(slide);
    });
    container.appendChild(wrapper);

    // Add pagination
    const pagination = document.createElement('div');
    pagination.classList.add('swiper-pagination');
    container.appendChild(pagination);

    swiper = new Swiper(container, {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: pagination,
        clickable: true,
      },
    });
  }

  function destroySlider() {
    if (!swiper) return;

    swiper.destroy(true, true);
    swiper = null;

    // Unwrap swiper structure
    const wrapper = container.querySelector('.swiper-wrapper');
    const pagination = container.querySelector('.swiper-pagination');
    if (wrapper) {
      const slides = Array.from(wrapper.children);
      slides.forEach(slide => {
        slide.classList.remove('swiper-slide');
        container.appendChild(slide);
      });
      wrapper.remove();
    }
    if (pagination) pagination.remove();
    container.classList.remove('swiper');
  }

  function handleResize(e) {
    if (e.matches) {
      initSlider();
    } else {
      destroySlider();
    }
  }

  mql.addEventListener('change', handleResize);
  handleResize(mql);
}
